import Axios from '../axios.js'

/**
 * 充值和消费记录接口
 */
export default {
	/**
	 * 查询指定账户的充值与消费记录,时间倒序排列
	 * @param {type} targetId 账户id
	 * @param {type} type 账户类型
	 * @param {type} pageIndex 页码
	 * @param {type} pageSize 页长
	 * @param {type} detailType 订单类型
	 * @param {type} beginTime 开始时间
	 * @param {type} endTime 结束时间
	 */
	searchRecordLimit: (targetIds, type, pageIndex, pageSize, detailType, beginTime, endTime, success, failure) => {
		Axios.post('/moneyRecord/searchRecordLimit.do', {
			targetIds,
			type,
			pageIndex,
			pageSize,
			detailType,
			beginTime,
			endTime
		}, success, failure);
	},
	/**
	 * 查询充值或消费记录详情
	 * @param {type} detailId 对应订单中的detailId
	 * @param {type} detailType 对应订单中的detailType
	 */
	searchRecordInfo: (detailId, detailType, success, failure) => {
		Axios.post('/moneyRecord/searchRecordInfo.do', {
			detailId,
			detailType
		}, success, failure);
	},
	/**
	 * 统计指定时间范围内指定账户的充值记录(不同充值方式在指定时间内充值总钱数)
	 * @param {type} targetId 账户id
	 * @param {type} type 账户类型
	 * @param {type} beginTime 开始时间
	 * @param {type} endTime 结束时间
	 */
	countPayRecord: (targetIds, type, beginTime, endTime, success, failure) => {
		Axios.post('/moneyRecord/countPayRecord.do', {
			targetIds,
			type,
			beginTime,
			endTime
		}, success, failure);
	},
	/**
	 * 统计指定时间范围内指定账户的充值与消费记录数(分开统计失败或成功数)
	 * @param {type} targetId 账户id
	 * @param {type} type 账户类型
	 * @param {type} beginTime 开始时间
	 * @param {type} endTime 结束时间
	 */
	countSuccessOrFailRecord: (targetIds, type, beginTime, endTime, success, failure) => {
		Axios.post('/moneyRecord/countSuccessOrFailRecord.do', {
			targetIds,
			type,
			beginTime,
			endTime
		}, success, failure);
	},

}